const TwoPartyFlag = ({ show = false, small = false }) => {
  if (!show) return null;
  return (
    <div className={`tw-py-0 tw-px-4px tw-rounded-4px tw-border-[2px] tw-border-solid tw-border-semantic-orange-50 tw-text-semantic-orange-50 tw-text-[8px] tw-font-bold tw-w-fit ${small ? 'tw-leading-[12px]' : 'tw-leading-[16px]'} tw-uppercase`}>
      2-party
    </div>
  );
};

export default TwoPartyFlag;
